import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
//import { withTranslation } from "react-i18next"
import { withRouter } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getLeadCallLog, addLeadCallLog } from "../../../store/actions"
import Moment from 'react-moment';
import { isEmpty, map } from "lodash";
import {
  Row,
  Col,
  FormGroup,
  Label
} from "reactstrap"
import classnames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { withTranslation } from "react-i18next";
import SaveButton from "components/buttons/save";
import moment from "moment-timezone";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class CallLog extends Component {
  constructor(props) {
    super(props)
    this.state = {


    }
    this.handSubmit = this.handSubmit.bind(this)
  }
  handSubmit(value) {
    this.props.addLeadCallLog(value, this.props.history)
  }
  componentDidMount() {
    const { match: { params }, onGetLeadCallLog } = this.props;
    onGetLeadCallLog(params.id);
  }
  render() {
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { calllogs } = this.props;
    return (
      <React.Fragment>

        <Formik
          enableReinitialize={true}
          initialValues={{
            actionType: 'Call',
            addedDate: new Date(),
            refId: this.props.match.params.id,
            callNote: (this.state && this.state.callNote) || "",


          }}
          validationSchema={Yup.object().shape({
            actionType: Yup.string().required(
              "Please Select Action"
            ),
            callNote: Yup.string().max(500, 'This filed contains only 500 characters only')
          })}


          onSubmit={(values) => {
            const formattedValues = {
              ...values,
              addedDate: moment(values.addedDate).format('YYYY-MM-DD'),

            };
            this.props.addLeadCallLog(formattedValues);


          }}
        >
          {({ errors, touched, values, handleChange, setFieldValue }) => (
            <Form
              className="needs-validation"
            >

              <Row className="mb20">



                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="builderName">
                      {this.props.t("Select Type")}
                    </Label>
                    <div className="clearfix"></div>
                    <div className="btn-group" role="group">
                      <SafeField type="radio" className="btn-check"
                        name="actionType" id="actionType1"
                        value='Call'
                        checked={values.actionType === 'Call'}
                        onChange={() => {
                          setFieldValue("actionType", 'Call')

                        }}
                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType1">Call</label>

                      <SafeField type="radio" className="btn-check" name="actionType" id="actionType2" value='No Answer'
                        checked={values.actionType === 'No Answer'}

                        onChange={() => {
                          setFieldValue("actionType", 'No Answer')

                        }}

                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType2">No Answer</label>

                      <SafeField type="radio" className="btn-check" name="actionType" id="actionType3"
                        value={4}
                        checked={values.actionType === 'Left Voicemail'}

                        onChange={() => {

                          setFieldValue("actionType", "Left Voicemail")
                        }}
                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType3">Left Voicemail</label>

                      <SafeField type="radio" className="btn-check" name="actionType" id="actionType4" value='Bad Number'
                        checked={values.actionType === 'Bad Number'}

                        onChange={() => {
                          setFieldValue("actionType", 'Bad Number')

                        }}

                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType4">Bad Number</label>
                    </div>
                    <ErrorMessage
                      name="activityType"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="addedDate">
                      Log Date
                    </Label>
                    <Flatpickr
                      className={
                        "form-control" +
                        (errors.addedDate && touched.addedDate
                          ? " is-invalid"
                          : "")
                      }
                      placeholder=""
                      value={values.addedDate}
                      onChange={(value) => setFieldValue('addedDate', value[0])}
                      options={{
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d"
                      }}
                    />
                    <ErrorMessage
                      name="addedDate"
                      component="div"
                      className="invalid-feedback"
                    />

                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="callNote">
                      Add Message
                    </Label>
                    <textarea
                      name="callNote"

                      type="textarea"
                      value={values.callNote}
                      onChange={(e) => setFieldValue("callNote", e.target.value)}
                      className={
                        "form-control" +
                        (errors.callNote && touched.callNote
                          ? " is-invalid"
                          : "")
                      }

                      id="callNote"

                    />
                    <ErrorMessage
                      name="callNote"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="clearfix">
                 {hasPermission("RealtorLeadsActivities", "Add") && (<SaveButton>Save</SaveButton>  )}
              </div>


            </Form>
          )}
        </Formik>
         {hasPermission("RealtorLeadsActivities", "View") && (
          <>
        {calllogs && calllogs.length > 0 ? (
          <>
            <div className="h4 card-title mt-20">Call Log History</div>
            <ul className="verti-timeline list-unstyled">

              {map(calllogs, (callLog, callkey) => (

                <li className="event-list eventlist" key={"_call_" + callkey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                    </div>
                  </div>
                  <div className="exNote">{callLog.activityRemarks}</div>
                </li>
              ))}

            </ul>
          </>
        ) : null}
        </>
      )}
      </React.Fragment>
    )
  }
}
CallLog.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
  match: PropTypes.object,
  onGetLeadCallLog: PropTypes.func,
  calllogs: PropTypes.array,
  addLeadCallLog: PropTypes.func

}
const mapStateToProps = ({ leads }) => (
  {
    calllogs: leads.calllogs,
  })
const mapDispatchToProps = dispatch => ({

  addLeadCallLog: (data) => dispatch(addLeadCallLog(data)),
  onGetLeadCallLog: (leadId) => dispatch(getLeadCallLog(leadId)),

});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CallLog)))

